import { ViewChild, ViewContainerRef, Input, OnDestroy, Component, AfterViewInit } from '@angular/core';

import { Subscription, take } from 'rxjs';

import { ConfigService } from '../../../../../Core/Config/services/config.service';

import { BriefingConfigService } from '../../../../MonitorShared/services/briefing-config.service';

import { AbstractFormFieldComponent } from '../../FormField/abstract-form-field.component';
import { PanelFieldModel } from '../../../models/panel-field.model';
import { BlockFormComponent } from '../../BlockForm/block-form.component';

@Component({
    selector: 'agpr-panel-field',
    templateUrl: './panel-field.component.html',
    styleUrls: ['./panel-field.component.scss'],
    standalone: false
})
export class PanelFieldComponent extends AbstractFormFieldComponent implements AfterViewInit, OnDestroy {
    @ViewChild('formFieldsContainer', { read: ViewContainerRef }) fieldsContainer: ViewContainerRef;
    @Input() declare field: PanelFieldModel;

    showPanel: boolean = true;

    subscriptions: Subscription[] = [];

    constructor(
        private blockForm: BlockFormComponent,
        private briefingConfigService: BriefingConfigService,
        protected configService: ConfigService
    ) {
        super();
    }

    ngAfterViewInit(): void {
        // should only run for briefing mention blocks..
        if (this.field.hasAutoGenAccess) {
            this.subscriptions.push(
                this.briefingConfigService.getAutoGenInsightAccess().pipe(take(1)).subscribe(x => {
                    const isReseller = this.configService.hasBrandGUID() && !this.configService.brandGUIDIsPaMedia();
                    this.showPanel = this.field.hasAutoGenAccess(x && !isReseller);
                    if (this.showPanel) {
                        this.createFields();
                    }
                })
            );
        } else if (this.field.appearCondition) {
            this.showPanel = this.field.appearCondition(this.block);
            if (this.showPanel) {
                this.createFields();
            }
        } else {
            this.createFields();
        }
    }

    createFields() {
        this.field.fields.forEach((field, i) => {
            this.blockForm.createField(field, this.id + '_' + i, this.fieldsContainer);
        });
    }

    ngOnDestroy(): void {
        this.fieldsContainer?.clear();
        this.subscriptions?.forEach(sub => sub.unsubscribe());
    }
}
